import React from 'react';
import { i18n_episodes } from '@yi/i18n/phrases/i18n_episodes';
import { i18n_season } from '@yi/i18n/phrases/i18n_season';
import { i18n_seasons } from '@yi/i18n/phrases/i18n_seasons';

import { useLocale } from '~/src/components/LocaleProvider';

import { H3 } from './elements';

type Props = {
  seasons: number;
  episodes: number;
};
export const TotalSeasonsEpisodesTitle: React.FC<Props> = ({ seasons, episodes }) => {
  const { locale } = useLocale();
  return (
    <H3>
      {seasons} {seasons > 1 ? i18n_seasons(locale) : i18n_season(locale)},{' '}
      {`${episodes} ${i18n_episodes(locale)}`}
    </H3>
  );
};
